import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/cn';

export interface NativeSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
}

export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, children, error, ...props }, ref) => {
    return (
      <div className="native-select-wrapper">
        <select
          ref={ref}
          className={cn(
            'native-select',
            error && 'native-select-error',
            className
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown className="native-select-icon" aria-hidden="true" />
      </div>
    );
  }
);

NativeSelect.displayName = 'NativeSelect';
